class Resources {
  dir = '/img'
  notfoundLogo = this.dir + '/404Logo.png'
  notfoundText = this.dir + '/404Text.png'

  maintenanceLogo = this.dir + '/maintenanceLogo.png'

  iconBackgroundImage(rank: number) {
    return (
      this.dir +
      ['', '/firstIconSp.png', '/secondIconSp.png', '/thirdIconSp.png'][rank]
    )
  }

  iconBadgeImage(rank: number) {
    return (
      this.dir +
      ['', '/firstBadge.png', '/secondBadge.png', '/thirdBadge.png'][rank]
    )
  }
}

export default Resources
